var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgShoppingcart = function SvgShoppingcart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,6 L6.81255236,6 C10.0632736,6 12.7227563,8.58874254 12.8103726,11.8382828 L13.2774585,29.1617172 C13.3650748,32.4112575 16.0245576,35 19.2752788,35 L40,35",
    stroke: "#8D91A2",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D91A2",
    cx: 19.5,
    cy: 41.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D91A2",
    cx: 36.5,
    cy: 41.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0615234,11.5029297 L40.6333848,11.5029297 C41.7379543,11.5029297 42.6333848,12.3983602 42.6333848,13.5029297 C42.6333848,13.6493257 42.6173111,13.7952792 42.5854527,13.9381666 L41.2332409,20.0029297 C40.1257373,24.9701599 35.7185485,28.5029297 30.6293501,28.5029297 L13.5419922,28.5029297",
    stroke: "#8D91A2",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))));
};
export default SvgShoppingcart;